import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-width: 100%;
  display: flex;
  margin-bottom: 12px;
  column-gap: 4px;
`;
